import React, { useState, createContext, useEffect, useRef } from "react";
import { Drawer } from "antd";
import useRtc from "@/hooks/use-rtc";
import useQuery from "@/hooks/use-query";
import Participants from "./Participants";
import Header from "./Header";
import Content from "./Content";
import Footer from "./Footer";
import Chat from "@/component/Chat";
import { BoardCommond, Commond, RtcType, ShowLayout } from "@/types";
import { METTINGPAGE_SAVED_MEETING_INFO, WSSSERVER,NORMALSETTINGKEY ,LOGININFOSTORE} from "@/config/const";
import ee from "@/util/event";
import VideoCard from './Content/VideoCard/index'; // 导入 VideoCard

import style from "./style.module.scss";
import {
  AnyType,
  BoolType,
  ConfefenctType,
  ConferenceInterface,
  ParticipantType,
} from "@/types";
import { storage } from "@/util";
import { useHistory } from "react-router-dom";
import { set } from "js-cookie";
import { Message } from "@/types";
import { useMqtt } from "@/hooks/use-mqtt";
import { canHandleBroadcastLayout } from "./broadcast-layout";

export const MeetingContext = createContext<
  RtcType & {
    conference?: ConferenceInterface;
    displayParticipants: ParticipantType[];
    isMonitorMode: boolean;
    videoFitMode: "cover" | "contain";
  }
>(null);

const Meeting: React.FC = () => {
  const { username, audio, video, speaker, simulcast } = useQuery();
  const [layout, setLayout] = useState<ShowLayout>(ShowLayout.Gallery);
  const [galleryPageSize, setGalleryPageSize] = useState(9);
  const [videoFitMode, setVideoFitMode] = useState<"cover" | "contain">("cover");
  // 是否跟随共享自动切换
  const [autoFollow, setAutoFollow] = useState(true);
  // 当前共享会话轮次（每次共享状态边沿变化自增）
  const shareEpochRef = useRef(0);
  const prevShareActiveRef = useRef(false);
  const [drawerVisible, setDrawerVisible] = useState(true);
  const history = useHistory();
  const [alarmTitle, setAlarmTitle] = useState<string | null>(null);
  const [messageList,setMessageList] =useState<Message[]>([])

  const { subscribe, publish, setTopic, setCallback, unSubscribe } = useMqtt()

  const participant = {
    // 示例：参与者信息
    peerId: 'user1',
    peerName: '用户1',
    audio: true,
    local: false,
    active: true,
  };

  const [rtcParams, setRtcParams] = useState({
    roomId: '',
    username: '',
    userId: '',
    audio: false,
    video: false,
    speaker: false,
    simulcast: false,
  });

  useEffect(() => {
      const { roomId, userId, username, audio, video, speaker, simulcast } = getParamsFromCurrentUrl();
      setRtcParams({
            roomId,
            username,
            userId,
            audio: audio === 'true',
            video: video === 'true',
            speaker: speaker === 'true',
            simulcast: simulcast === 'true'
          });
    console.log(`[Meeting] useEffect username=${username} audio=${audio} video=${video}, speaker=${speaker},simulcast=${simulcast}`)

    // setCallback(Commond.otherJoinRoom, (payload: any) => {
    //   console.log(`[Meeting] Joined room ${roomId} as ${username} ${JSON.stringify(payload)}`);
    // })
  }, [])

  useEffect(() => {
    if (rtcParams.roomId)
      setTopic(rtcParams.roomId)
      publish({ command: Commond.otherJoinRoom, data: { username: rtcParams.username, userId: rtcParams.userId } });
  }, [rtcParams.roomId, setTopic, publish, rtcParams.username, rtcParams.userId])

  useEffect(() => {
    const openAiRecord = () => {
      setDrawerVisible(true);
    };
    ee.on("openAiRecord", openAiRecord);
    return () => {
      ee.off("openAiRecord", openAiRecord);
    };
  }, []);

   // 从网址上获取相应的字段
   const getParamsFromCurrentUrl = () => {
    const hash = window.location.hash;
  console.log(hash, 'URL hash'); // 打印哈希以确认

  // 解析 hash 中的查询参数
  const queryString = hash.split('?')[1]; // 获取 ? 之后的部分
  const urlParams = new URLSearchParams(queryString); // 使用 URLSearchParams 解析查询字符串
    // 从查询参数中提取 username 和 peerId
    const username = urlParams.get('username');
    const peerId = urlParams.get('peerId');
    const audio = urlParams.get('audio');
    const video = urlParams.get('video');
    const speaker = urlParams.get('speaker');
    const simulcast = urlParams.get('simulcast');
  
    // 从 peerId 中提取 roomId 和 userId
    let roomId = '';
    let userId = '';
    if (peerId) {
      
      [roomId, userId] = peerId.split('_');
    }
     console.log(username ,'这是从网址获取的字段数据')
     console.log(peerId,'这是从网址获取的字段数据')
     console.log(roomId,'这是从网址获取的字段数据')
     console.log(userId,'这是从网址获取的字段数据')
     return { roomId, userId, username, audio, video, speaker, simulcast };
  };
 
  const conf: ConferenceInterface = storage.get(
    METTINGPAGE_SAVED_MEETING_INFO
  ) as ConferenceInterface;
  const { userId } = conf;
  
  const emit = (evt: string, id: string) => {
    if (evt === "removeUser") {
      const uid = id.split("_")[1];
      if (uid === userId) {
        history.go(-1);
      }
    }
  };
  console.log(`useRtc server:${WSSSERVER}`);
  if(!conf){
       getParamsFromCurrentUrl()
   }

  const { participants, service, conference, updateConference, setParticipants } = useRtc(
    {
      server: WSSSERVER,
      roomId: rtcParams.roomId || conf.roomId,
      username,
      uid: `${rtcParams.roomId || conf.roomId}_${rtcParams.userId || userId}`,
      audio: rtcParams.audio || audio == "true",
      video: rtcParams.video|| video == "true",
      speaker: rtcParams.speaker|| speaker == "true",
      simulcast: rtcParams.simulcast|| simulcast == "true",
      conf,
      emit,
    }
  );
  const isMonitorMode = (rtcParams.userId || userId || "").startsWith("monitor");
  const displayParticipants = React.useMemo<ParticipantType[]>(
    () => isMonitorMode ? participants.filter((peer) => !peer.local) : participants,
    [isMonitorMode, participants]
  );
  const loginfo = storage.get(LOGININFOSTORE);
  const leaveMonitorMeeting = async () => {
    try {
      await service.close();
    } finally {
      unSubscribe();
      history.replace("/");
    }
  };
  React.useEffect(() => {
    setCallback(Commond.broadcastParticipant, (payload?: { peerId?: string; operatorPeerId?: string }) => {
      if (!payload?.peerId || !canHandleBroadcastLayout(conference, participants, payload.operatorPeerId)) {
        return;
      }

      setAutoFollow(false);
      service.pin(payload.peerId, true);
      setLayout(ShowLayout.Thumbnail);
      service.switchToSpeakerView();
    });

    return () => {
      setCallback(Commond.broadcastParticipant, () => undefined);
    };
  }, [conference, participants, service, setCallback]);

  const handleLayoutChange = (type: ShowLayout) => {
    // 只要是用户点的，就认为是“手动覆盖”
    setAutoFollow(false);
    // if (type !== ShowLayout.Thumbnail) {
    //   service.pin("", false);
    // }
    setLayout(type);
    
    // if (type === ShowLayout.Speaker || type === ShowLayout.Dual) {
    //   service.switchToSpeakerView();
    // } else {
    //   service.switchToOtherView();
    // }

    if (type === ShowLayout.Gallery) {
      service.switchToOtherView();
    } else {
      service.switchToSpeakerView();
    }
  };

  // 2. 添加一个 ref 来跟踪 *上一次* 的共享状态
  const prevIsSharingActive = useRef(false);

  // React.useEffect(() => {
  //   const haveShared = participants.find((d) => d.share);
  //   const lay =
  //     (haveShared || board.boardShow) && layout === ShowLayout.Gallery
  //       ? ShowLayout.Thumbnail
  //       : layout;
  //   setLayout(lay);
  // }, [board.boardShow, layout, participants]);

  // const realLayout: ShowLayout = React.useMemo(() => {
  //   const haveShared = participants.find((d) => d.share);
  //   const lay =
  //     (haveShared || board.boardShow) && layout === ShowLayout.Gallery
  //       ? ShowLayout.Thumbnail
  //       : layout;
  //   return lay;
  // }, [layout, participants, board]);

  // const [showLayout, setShowLayout] = React.useState<ShowLayout>(
  //   ShowLayout.Gallery
  // );

  // React.useEffect(() => {
  //   if (realLayout === ShowLayout.Thumbnail) {
  //     setShowLayout(ShowLayout.Speaker);
  //     setTimeout(() => {
  //       setShowLayout(ShowLayout.Thumbnail);
  //     }, 200);
  //   } else {
  //     setShowLayout(realLayout);
  //   }
  // }, [realLayout]);

  // // 这个 Effect 会自动响应 participants 状态的变化来切换布局
  // // 3. 替换掉旧的 useEffect
  // React.useEffect(() => {
  //   // 检查 *当前* 的共享状态
  //   const currentIsSharingActive = participants.some((p) => p.share === true);

  //   // 检查共享状态是否 *发生变化*
  //   if (
  //     currentIsSharingActive &&
  //     prevIsSharingActive.current === false
  //   ) {
  //     // 变化：共享刚刚 *开始* (false -> true)
  //     // 强制切换到演讲者模式
  //     console.log("[Meeting] 共享流开始，自动切换到演讲者布局");
  //     setLayout(ShowLayout.Speaker);
  //   } else if (
  //     !currentIsSharingActive &&
  //     prevIsSharingActive.current === true
  //   ) {
  //     // 变化：共享刚刚 *停止* (true -> false)
  //     // 自动切回画廊模式
  //     console.log("[Meeting] 共享流停止，自动切回画廊布局");
  //     setLayout(ShowLayout.Gallery);
  //   }

  //   // 在 Effect 最后，更新 ref 为当前状态，供下一次渲染比较
  //   prevIsSharingActive.current = currentIsSharingActive;

  // }, [participants]); // 依赖项 *只* 应该是 participants

  React.useEffect(() => {
    const hasShare = participants.some(p => p.share === true);

    // 共享边沿检测
    if (hasShare !== prevShareActiveRef.current) {
      // 共享状态发生变化，进入新会话
      shareEpochRef.current += 1;

      // 如果从 true -> false（共享结束），恢复自动跟随
      if (!hasShare) {
        setAutoFollow(true);
      }

      prevShareActiveRef.current = hasShare;
    }

    // 自动切换逻辑（仅在 autoFollow === true 时生效）
    if (autoFollow) {
      if (hasShare) {
        if (layout !== ShowLayout.Speaker) setLayout(ShowLayout.Speaker);
      } else {
        if (layout === ShowLayout.Speaker) setLayout(ShowLayout.Gallery);
      }
    }
  }, [participants, layout, autoFollow]);

  const footerShareOpen = (v: string) => {
    if (v === "board") {
      service.sendCustomCmdMsg({
        cmdId: BoardCommond.BoardOpen,
        data: {},
      });
      //board.setBoardShow(true);
    }
    if (layout === ShowLayout.Gallery) {
      // setLayout(ShowLayout.Side);
    }
  };

  const boardShowHandler = () => {
    setLayout(ShowLayout.Side);
  };

  // const shareShowHandler = () => {
  //
  //   console.log(`[Meeting] shareShowHandler`);
  //   //setLayout(ShowLayout.Speaker);
  //   setTimeout(() => {
  //     setLayout(ShowLayout.Speaker);
  //   }, 400);
  // };

  // const onAlarmEvent = (peerId: string, alarmTitle: string) => {
  //     //播放报警声音
  //     const audio = new Audio();
  //     audio.src = require('@/assets/alarm.mp3');
  //     audio.play();
  //     console.log(`[Meeting] onAlarmEvent alarmTitle=${alarmTitle}`);
  //         // 实时更新 alarmTitle
  //   //setAlarmTitle(alarmTitle);
  //   console.log(`[Meeting] onAlarmEvent peerId=${peerId} alarmTitle=${alarmTitle}`);
  //     service.setParticipantSubTitle(peerId, alarmTitle);
  //     service.removeParticipantSubTitle(peerId);
  //     //展示模式的大视频框显示字幕，字幕内容为alarmTitle
  //     // setAlarmTitle(alarmTitle);
  // };

  const  ShowSubtitles =(peerId: string, chatTitle: string, username:string) =>{
    console.log(`[Meeting] ShowSubtitles chatTttle=${chatTitle} username=${username}`);
    console.log(username,"能否接受到用户的ID")
    let newMessage :Message ={
      id:peerId,
      user:username,
      content:chatTitle,
      timestamp:new Date().toLocaleTimeString(),
    }
  setMessageList((prevMessages) => {
    // 检查是否已经存在相同的消息内容
    const messageExists = prevMessages.some(
      (msg) => msg.content === chatTitle && msg.user === username
    );
    
    // 只有在消息不存在时才添加
    // if (!messageExists) {
    //   return [...prevMessages, newMessage];
    // }

    // 如果消息已存在，则返回原消息列表
    return [...prevMessages, newMessage];;
  });
    //  const messageListcopt = [...messageList]
    //  messageListcopt.push(newMessage)
    //  setMessageList(messageListcopt)

  }

  // const openVideoHandler = () => {
  //   const alayout = layout;
  //   setLayout(ShowLayout.Speaker);
  //   setTimeout(() => {
  //     setLayout(alayout);
  //   }, 200);
  // };

  // React.useEffect(() => {
  //   // ee.on("boardshow", boardShowHandler);
  //   ee.on("openshare", shareShowHandler);
  //   // joinMeeting();
  //   // ee.on("alarmEvent", onAlarmEvent);
  //   ee.on("chatEvent", ShowSubtitles);
  //
  //   // ee.on("openVideo", openVideoHandler);
  //   return () => {
  //     //ee.off("boardshow", boardShowHandler);
  //   ee.off("openshare", shareShowHandler);
  //     //ee.off("openVideo", openVideoHandler);
  //   };
  // }, []);


// 通过上下文获取 conference 主持人信息
  return (
    <MeetingContext.Provider
      value={{
        participants,
        displayParticipants,
        isMonitorMode,
        videoFitMode,
        service,
        conference,
        updateConference,
        setParticipants
      }}
    >
      <div className={style.container}>
        <div
          className={`${style.left} hidden`}
          style={{ paddingRight: drawerVisible ? 320 : 0 }}
        >
          <div className={style.header}>
            <Header
              layout={layout}
              onLayoutChange={handleLayoutChange}
              isMonitorMode={isMonitorMode}
              galleryPageSize={galleryPageSize}
              onGalleryPageSizeChange={setGalleryPageSize}
              videoFitMode={videoFitMode}
              onVideoFitModeChange={setVideoFitMode}
              participantsVisible={drawerVisible}
              onToggleParticipants={() => setDrawerVisible((visible) => !visible)}
              onMonitorLeave={leaveMonitorMeeting}
            />
            
          </div>
          <div className={style.content}>
              
              {conference.isHostLeave && <div >主持人已离开</div>}
             
            <Content
              participants={displayParticipants}
              layout={layout}
              galleryPageSize={galleryPageSize}
            />
          </div>
          {!isMonitorMode && (
            <div className={style.footer}>
              <Footer
                showParticipants={() => setDrawerVisible(!drawerVisible)}
                open={(v) => footerShareOpen(v)}
              />
            </div>
          )}
        </div>
        <Drawer
          className={style.drawer}
          width={320}
          visible={drawerVisible}
          mask={false}
          closable={false}
          // onClose={() => setDrawerVisible(false)}
        >
          <Participants onParticipantsClose={() => setDrawerVisible(false)} messageList={messageList} />
        </Drawer>
        <Chat />
      </div>
    </MeetingContext.Provider>
  );
};

export default Meeting;
